import React, { useState } from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Card,
  CardContent,
  Chip,
  Button,
  Switch,
  FormControlLabel,
} from '@mui/material';
import { ArrowBack, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AvailabilityPage: React.FC = () => {
  const navigate = useNavigate();
  const [isAvailable, setIsAvailable] = useState(true);

  const availability = [
    { day: 'Monday', status: 'available', hours: '07:00 - 15:00' },
    { day: 'Tuesday', status: 'available', hours: '07:00 - 15:00' },
    { day: 'Wednesday', status: 'unavailable', hours: '-' },
    { day: 'Thursday', status: 'available', hours: '15:00 - 23:00' },
    { day: 'Friday', status: 'available', hours: '07:00 - 15:00' },
    { day: 'Saturday', status: 'preferred', hours: '07:00 - 15:00' },
    { day: 'Sunday', status: 'unavailable', hours: '-' },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#1a1a2e' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2, fontWeight: 700, flexGrow: 1 }}>
            Availability
          </Typography>
          <IconButton color="inherit">
            <Add />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2 }}>
        <Card sx={{ mb: 2, borderRadius: 3 }}>
          <CardContent>
            <FormControlLabel
              control={
                <Switch
                  checked={isAvailable}
                  onChange={(e) => setIsAvailable(e.target.checked)}
                  color="primary"
                />
              }
              label="Mark myself as available for shifts"
              sx={{ display: 'block' }}
            />
          </CardContent>
        </Card>

        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
          Weekly Availability
        </Typography>

        {availability.map((day, index) => (
          <Card key={index} sx={{ mb: 1, borderRadius: 2 }}>
            <CardContent sx={{ py: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    {day.day}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {day.hours}
                  </Typography>
                </Box>
                <Chip
                  label={day.status}
                  size="small"
                  color={
                    day.status === 'available'
                      ? 'success'
                      : day.status === 'preferred'
                      ? 'primary'
                      : 'default'
                  }
                  variant={day.status === 'preferred' ? 'filled' : 'outlined'}
                />
              </Box>
            </CardContent>
          </Card>
        ))}

        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 2, py: 1.5, bgcolor: '#E91E63' }}
          onClick={() => navigate('/schedule')}
        >
          Save Availability
        </Button>
      </Box>
    </Box>
  );
};

export default AvailabilityPage;
